export const get_settings = (state) => state.settings;
export const get_community = (state) => state.community;
export const get_register_info = (state) => state.register_info;
